import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import React, { memo } from "react";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { AvatarList, avatarListClasses } from "./AvatarList";
import { Box } from "./Box";
import { HorizontalScroller } from "./HorizontalScroller";
import { Tooltip } from "./Tooltip";
import { Typography } from "./Typography";
export const avatarGroupClasses = {
    root: "MinervaAvatarGroup-root",
    "overflow-indicator": "MinervaAvatarGroup-overflowIndicator",
    "overflow-list": "MinervaAvatarGroup-overflowList",
};
export const avatarGroupSlots = {
    overflowIndicator: Box,
    typography: Typography,
    tooltip: Tooltip,
    horizontalScroller: HorizontalScroller,
    overflowList: AvatarList,
};
export const AvatarGroup = memo((props) => {
    const { children, max = React.Children.count(children), size = "sm", color = "surface", colorSet = "container", invertColors, slots, slotProps, overlap: _overlap, className, ...rest } = useDefaultProps({ component: "AvatarGroup", props });
    const childrenArray = React.Children.toArray(children);
    const avatarsToShow = childrenArray.slice(0, max);
    const remainingAvatars = childrenArray.slice(max);
    const numRemainingAvatars = childrenArray.length - max;
    const overlap = {
        xxs: 1,
        xs: 1.5,
        sm: 2,
        md: 2.5,
        lg: 3,
        xl: 3.5,
    };
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: (colorStyles) => (_jsx(SlotsProvider, { baseSlots: avatarGroupSlots, slots: slots, children: ({ overflowIndicator: OverflowIndicator, typography: Typography, tooltip: Tooltip, horizontalScroller: HorizontalScroller, overflowList: OverflowList, }) => (_jsxs(AvatarList, { size: size, className: clsx([avatarGroupClasses.root, className]), overlap: _overlap ?? typeof size === "number" ? overlap.sm : overlap[size], ...rest, children: [avatarsToShow, numRemainingAvatars > 0 && (_jsx(Tooltip, { title: _jsx(HorizontalScroller, { ...slotProps?.horizontalScroller, children: _jsx(OverflowList, { overlap: 2, ...slotProps?.overflowList, className: clsx([
                                    avatarGroupClasses["overflow-list"],
                                    slotProps?.overflowList?.className,
                                ]), children: remainingAvatars }) }), density: "dense", ...slotProps?.tooltip, children: _jsx(OverflowIndicator, { ...slotProps?.overflowIndicator, className: clsx([
                                avatarGroupClasses["overflow-indicator"],
                                avatarListClasses.avatar,
                                slotProps?.overflowIndicator?.className,
                            ]), sx: mergeSx({
                                ...colorStyles,
                                borderRadius: (theme) => theme.radius.full,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                            }, slotProps?.overflowIndicator?.sx), children: _jsxs(Typography, { variant: "title4", fontWeight: "bold", ...slotProps?.typography, children: ["+", numRemainingAvatars] }) }) }))] })) })) }));
});
//# sourceMappingURL=AvatarGroup.js.map